<div class="root-body">
    <p-toast position="top-right"></p-toast>

    <p-sidebar *ngIf="showEditSideBar"
               [(visible)]="showEditSideBar"
               [position]="'right'"
               [baseZIndex]="10000"
               (onHide)="closeSideBar()"
               [style]="{width:'520px'}">
        <ng-template pTemplate="header">
            <div class="sidebar-header-title">{{ sponsor.Id ? 'Edit Sponsor' : 'Create Sponsor' }}</div>
        </ng-template>

        <div class="p-3">
            <div class="sidebar-field-block">
                <div class="sidebar-field__label">Sponsor Name</div>
                <input type="text" [(ngModel)]="sponsor.Name" placeholder="Enter Sponsor Name" pInputText />
            </div>

            <div class="sidebar-field-block flex align-items-center" style="gap: 10px;">
                <p-inputSwitch [(ngModel)]="sponsor.IsActive"></p-inputSwitch>
                <span>{{ sponsor.IsActive ? 'Active' : 'Inactive' }}</span>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="flex justify-content-end p-3" style="gap: 12px;">
                <button pButton class="white-btn-filter" label="Cancel" (click)="closeSideBar()"></button>
                <button pButton class="bluedark-btn-filter" label="Save" (click)="save()"></button>
            </div>
        </ng-template>
    </p-sidebar>

    <div class="card">
        <p-table [columns]="cols"
                 [value]="sponsors"
                 [lazy]="true"
                 responsiveLayout="scroll" dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [loading]="loading"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(80vh)'}">
            <ng-template pTemplate="caption">
                <div class="flex flex-row sp-header">
                    <div class="sp-header__col-left">
                        <div class="sp-header__title">Promo Sponsors</div>
                    </div>
                    <div class="flex flex-row sp-header__col-right">
                        <div class="ml-20">
                            <button class="bluedark-btn-filter" pButton label="Create Sponsor" (click)="openCreate()"></button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols" [style.width]="col.width">{{ col.header }}</th>
                    <th style="width: 130px;">Status</th>
                    <th style="width: 90px;">Action</th>
                </tr>
                <tr>
                    <th></th>
                    <th>
                        <input type="text" pInputText placeholder="Search name" [(ngModel)]="filter.SearchName"
                               (input)="handleHeaderFilterChange()" />
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sponsor>
                <tr>
                    <td *ngFor="let col of cols">{{ sponsor[col.field] }}</td>
                    <td>
                        <div class="flex flex-row align-items-center" style="gap: 8px;">
                            <p-inputSwitch [(ngModel)]="sponsor.IsActive" (onChange)="switchActive(sponsor)"></p-inputSwitch>
                            <span *ngIf="sponsor.IsActive">Active</span>
                            <span *ngIf="!sponsor.IsActive">Inactive</span>
                        </div>
                    </td>
                    <td>
                        <span class="action-icon-svg" style="cursor: pointer;" (click)="openEdit(sponsor)">
                            <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="cols.length + 2" style="text-align: center;">No sponsors found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
                <div *ngIf="sponsors && sponsors.length > 0" style="padding-left: 10px">
                    Displaying {{ first + 1 }} - {{ first + sponsors.length }} of {{ totalRecords }}
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
